// extracted by mini-css-extract-plugin
export var externalLink = "_9i-0";
export var internalLinkLabel = "_9i-1";